<script>
  import TextInput from '../../../../components/inputs/text';
  import TextAreaInput from '../../../../components/inputs/textarea'
  import RichTextInput from '../../../../components/inputs/richtext';
  import Form from '../../../../components/inputs/form';
  import SponsorInput from '../../../../components/inputs/sponsor';
  import Trash from '../../../../components/buttons/trash.card';
  import ImageInput from '../../../../components/inputs/image';

  export let value;
  export let review = false;
  export let readonly = false;
  export let u


  function addSponsor() {
    value.sponsors = [...(value.sponsors || []), { id: '' }]
  }

  function removeSponsor(i) {
    value.sponsors = value.sponsors.filter((sponsor, index) => i !== index)
  }

  const headerOptions = {
    cropAspectRatio: 0.5
  }



</script>



<div>
  <Form>
    <input type="hidden" value="{u}" />
    <div class="form-group">
      <TextAreaInput readonly="{readonly}" bind:value={value.shortDescription} label="Short Description"
        placeholder="Short Description" />
    </div>
    <div class="form-group">
      <TextAreaInput readonly="{readonly}" bind:value={value.description} label="Description"
        placeholder="Description" />
    </div>
    <div class="form-group">
      <TextAreaInput readonly="{readonly}" bind:value={value.partnerQuote} label="Partner Quote"
        placeholder="Partner Quote" />
    </div>
    <div class="form-group">
      <TextAreaInput readonly="{readonly}" bind:value={value.takeNote} label="Take Note" placeholder="Take Note" />
    </div>
    <label>Program Sponsors</label>
    <div class="form-group form-group-repeater">
      {#each value.sponsors as sponsor, i}
      <Form>
        <Trash on:click="{() => removeSponsor(i)}" />
        <div class="form-group">
          <SponsorInput readonly="{readonly}" bind:value={sponsor.id} label="Sponsor" />
        </div>
      </Form>
      {/each}
      {#if !readonly}
      <div on:click="{addSponsor}" class="form-group-add">Add Program Sponsor</div>
      {/if}
    </div>
    <div class='grid-x'>
      <div class="cell small-12">
        <div class="form-group">
          <ImageInput options={headerOptions} readonly="{readonly}" bind:value={value.headerImage} label="Header Image"
            placeholder="Header Image" />
        </div>
      </div>
      <div class="cell small-12 medium-{review ? 4 : 3}">
        <div class="form-group">
          <ImageInput readonly="{readonly}" bind:value={value.cardImage} label="Card Image" placeholder="Card Image" />
        </div>
      </div>
    </div>
  </Form>
</div>